export enum BookingFormGeneralErrorTypes {
  PATTERN = 'pattern',
  AGE_RANGE = 'age-range',
  INVALID_DATE = 'invalid-date',
  BIRTHDATE_LESSER_THAN_ALLOWED = 'birthdate-lesser-than-allowed',
  BIRTHDATE_GREATER_THAN_ALLOWED = 'birthdate-greater-than-allowed',
  DOCUMENT_ERROR = 'document-error',
  PASSPORT_RESTRICTION = 'passport-restriction',
  MASK = 'mask',
  INVALID_DOCUMENT_VALUE = 'invalid-document-value',
  INVALID_BONVOY_NUMBER = 'invalid-bonvoy-number'
}
